/**
 * Image formats accepted for POST /api/v1/media (IFKL-1061).
 * HEIC/HEIF/BMP are converted to PNG on the server; preview via response `link`/`name`.
 */

/** Extension list for `<input accept>` and extension-based validators. */
export const ACCEPT_IMAGE_EXTENSIONS =
  '.png, .jpg, .jpeg, .heic, .heif, .bmp, .webp';

/** MIME list for upload components that match on `file.type`. */
export const ACCEPT_IMAGE_MIME =
  'image/png, image/jpeg, image/jpg, image/heic, image/heif, image/bmp, image/webp';

/** When the browser omits/mislabels MIME, accept by filename extension. */
export const IMAGE_MIME_EXTENSION_FALLBACKS: Record<string, string[]> = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/jpg': ['.jpg', '.jpeg'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif'],
  'image/bmp': ['.bmp'],
  'image/webp': ['.webp'],
};

/** Prefer server `link` for these — browsers often cannot render the raw file. */
export function needsServerImagePreview(fileName: string): boolean {
  const name = (fileName || '').toLowerCase();
  return (
    name.endsWith('.heic') ||
    name.endsWith('.heif') ||
    name.endsWith('.bmp')
  );
}

/** Extract validation message for multipart field `file` from media upload errors. */
export function getMediaUploadFileError(error: unknown): string | null {
  const body = (error as { error?: any })?.error;
  if (!body) {
    return null;
  }
  const fileErrors =
    body?.errors?.file ??
    body?.data?.errors?.file ??
    body?.data?.file ??
    body?.file;
  if (Array.isArray(fileErrors) && fileErrors[0] != null) {
    return String(fileErrors[0]);
  }
  if (typeof fileErrors === 'string' && fileErrors) {
    return fileErrors;
  }
  if (typeof body?.message === 'string' && body.message) {
    return body.message;
  }
  return null;
}
